'use strict';

function CompanyPublicationOrderService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/publications/:publicationId/massoptimering', {}, {
    'update': {
      method: 'PUT'
    },
    'delete': {
      url: config.apiBase + '/companies/:companyId/publications/:publicationId/massoptimering/:massoptimeringId',
      method: 'DELETE'
    },
    'queryPlants': {
      url: config.apiBase + '/companies/:companyId/publications/:publicationId/massoptimering/:massoptimeringId/plants',
      method: 'GET',
      isArray: true
    },
    'addPlant': {
      url: config.apiBase + '/companies/:companyId/publications/:publicationId/massoptimering/:massoptimeringId/plants',
      method: 'POST'
    },
    'removePlant': {
      url: config.apiBase + '/companies/:companyId/publications/:publicationId/massoptimering/:massoptimeringId/plants/:id',
      method: 'DELETE'
    },
    'queryUsers': {
      url: config.apiBase + '/companies/:companyId/publications/:publicationId/massoptimering/:massoptimeringId/users',
      method: 'GET',
      isArray: true
    },
    'addUser': {
      url: config.apiBase + '/companies/:companyId/publications/:publicationId/massoptimering/:massoptimeringId/users',
      method: 'POST'
    },
    'removeUser': {
      url: config.apiBase + '/companies/:companyId/publications/:publicationId/massoptimering/:massoptimeringId/users/:id',
      method: 'DELETE'
    },
    'queryProjects': {
      url: config.apiBase + '/companies/:companyId/publications/:publicationId/massoptimering/:massoptimeringId/projects',
      method: 'GET',
      isArray: true
    },
    'addProject': {
      url: config.apiBase + '/companies/:companyId/publications/:publicationId/massoptimering/:massoptimeringId/projects',
      method: 'POST'
    },
    'removeProject': {
      url: config.apiBase + '/companies/:companyId/publications/:publicationId/massoptimering/:massoptimeringId/projects/:id',
      method: 'DELETE'
    },
    'queryDeliveries': {
      url: config.apiBase + '/companies/:companyId/publications/:publicationId/massoptimering/:massoptimeringId/deliveries',
      method: 'GET',
      isArray: true
    },
    'updateDelivery': {
      url: config.apiBase + '/companies/:companyId/publications/:publicationId/massoptimering/:massoptimeringId/deliveries/:deliveryId',
      method: 'PUT'
    },
    'download': {
      url: config.apiBase + '/companies/:companyId/publications/:publicationId/massoptimering/:massoptimeringId/deliveries?export=true',
      method: 'GET',
      transformResponse: function(data, headers) {
        var getFileNameFromHeader = function(header) {
          if (!header) {
            return null;
          }
          var result = header.split(";")[1].trim().split("=")[1];
          return result.replace(/"/g, '');
        };

        var excel = null;
        if (data) {
          excel = new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          });
        }
        var fileName = getFileNameFromHeader(headers('content-disposition'));
        var result = {
          blob: excel,
          fileName: fileName
        };
        return {
          response: result
        };
      }
    }
  });
}

angular.module('dokiv')
  .factory('CompanyPublicationOrderService', ['$resource', 'config', CompanyPublicationOrderService]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/order/CompanyPublicationOrderService.js
// module id = 12
// module chunks = 0